// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =========================
   GLOBAL
========================= */

* {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  margin: 0;
  background: #fffafc;
}


/* =========================
   FIXED BACKGROUND
========================= */

.home-fixed-background {
  position: fixed;

  inset: 0;

  width: 100vw;
  height: 100vh;

  z-index: 0;

  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  pointer-events: none;
}


/* FADED PEARL OVERLAY */

.home-fixed-overlay {
  position: fixed;

  inset: 0;

  width: 100vw;
  height: 100vh;

  z-index: 1;

  background:
    linear-gradient(
      110deg,
      rgba(255, 253, 251, 0.72) 0%,
      rgba(255, 250, 252, 0.67) 45%,
      rgba(255, 244, 249, 0.62) 100%
    );

  pointer-events: none;
}


/* =========================
   HOME
========================= */

.home {
  --pink: #e6007e;
  --pink-light: #ff4da6;
  --black: #080808;
  --soft-black: #181618;
  --pearl: #f8f5f2;
  --gray: #716a6e;

  position: relative;

  z-index: 2;

  min-height: 100vh;

  color: var(--soft-black);

  font-family: "Montserrat", sans-serif;
}


/* =========================
   EYEBROW
========================= */

.home-eyebrow {
  margin: 0 0 22px;

  color: var(--pink);

  font-size: 0.62rem;
  font-weight: 500;

  letter-spacing: 4px;

  text-transform: uppercase;
}


/* =========================
   HERO
========================= */

.home-hero {
  min-height: calc(100vh - 86px);

  display: flex;
  align-items: center;

  position: relative;

  padding:
    100px
    max(6%, calc((100vw - 1400px) / 2));

  background: rgba(255, 255, 255, 0.03);
}

.hero-content {
  width: 100%;
  max-width: 850px;

  position: relative;

  z-index: 2;
}

.hero-title {
  margin: 0;

  color: var(--black);

  font-family: "Cormorant Garamond", serif;

  font-size: clamp(4.8rem, 8vw, 8.8rem);
  font-weight: 400;

  line-height: 0.84;

  letter-spacing: -4px;
}

.hero-title span {
  display: block;

  margin-left: 11%;

  color: var(--pink);

  font-style: italic;
}

.hero-description {
  max-width: 580px;

  margin: 45px 0 0 11%;

  color: #494144;

  font-size: 0.88rem;
  font-weight: 400;

  line-height: 1.95;
}

.hero-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  gap: 32px;

  margin: 40px 0 0 11%;
}


/* =========================
   BUTTONS
========================= */

.home-primary-button {
  display: inline-block;

  padding: 17px 29px;

  color: #ffffff;

  background:
    linear-gradient(
      135deg,
      #ff3ca0,
      var(--pink),
      #c9006e
    );

  border: 1px solid rgba(255, 255, 255, 0.4);

  box-shadow:
    0 12px 30px rgba(230, 0, 126, 0.25);

  text-decoration: none;
  text-transform: uppercase;

  font-size: 0.61rem;
  font-weight: 500;

  letter-spacing: 2px;

  transition:
    transform 0.3s ease,
    box-shadow 0.3s ease;
}

.home-primary-button:hover {
  transform: translateY(-3px);

  box-shadow:
    0 18px 38px rgba(230, 0, 126, 0.35);
}

.home-text-link {
  display: inline-flex;
  align-items: center;

  gap: 13px;

  color: var(--black);

  text-decoration: none;
  text-transform: uppercase;

  font-size: 0.6rem;
  font-weight: 500;

  letter-spacing: 2px;
}

.home-text-link span {
  color: var(--pink);

  font-size: 1rem;

  transition: transform 0.3s ease;
}

.home-text-link:hover span {
  transform: translateX(5px);
}


/* =========================
   SHARED HEADINGS
========================= */

.home-intro h2,
.services-header h2,
.home-philosophy h2,
.experience-heading h2,
.professional-content h2,
.home-cta h2 {
  margin: 0;

  font-family: "Cormorant Garamond", serif;

  font-size: clamp(3.3rem, 6vw, 5.8rem);
  font-weight: 400;

  line-height: 0.95;

  letter-spacing: -2px;
}

.home-intro h2 em,
.home-philosophy h2 em,
.experience-heading h2 em,
.professional-content h2 em,
.home-cta h2 em {
  color: var(--pink);

  font-weight: 400;
}


/* =========================
   INTRO
========================= */

.home-intro {
  padding: 145px 6%;

  background: rgba(255, 253, 251, 0.72);

  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);

  text-align: center;
}

.intro-inner {
  max-width: 850px;

  margin: auto;
}

.intro-description {
  max-width: 680px;

  margin: 34px auto 0;

  color: var(--gray);

  font-size: 0.86rem;
  font-weight: 300;

  line-height: 2;
}

.intro-secondary {
  margin-top: 15px;
}

.intro-divider {
  max-width: 350px;

  margin: 48px auto 0;

  display: flex;
  align-items: center;

  gap: 20px;
}

.intro-divider span {
  flex: 1;

  height: 1px;

  background: #dfcfd7;
}

.intro-divider div {
  color: var(--pink);

  font-family: "Cormorant Garamond", serif;

  font-style: italic;
}


/* =========================
   SERVICES
========================= */

.home-services {
  padding:
    120px
    max(6%, calc((100vw - 1400px) / 2));

  background: rgba(248, 243, 245, 0.76);

  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.services-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  gap: 50px;

  margin-bottom: 70px;
}

.services-header-text {
  max-width: 410px;

  margin: 0;

  color: var(--gray);

  font-size: 0.8rem;

  line-height: 1.9;
}

.services-grid {
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  gap: 24px;
}


/* =========================
   SERVICE CARDS
========================= */

.home-service-card {
  min-height: 470px;

  padding: 32px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;

  overflow: hidden;

  color: var(--soft-black);

  background:
    linear-gradient(
      145deg,
      rgba(255, 255, 255, 0.94),
      rgba(255, 250, 252, 0.88)
    );

  border:
    1px solid
    rgba(255, 255, 255, 0.85);

  border-radius: 28px;

  box-shadow:
    0 15px 45px rgba(65, 40, 52, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);

  text-decoration: none;

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  transition:
    transform 0.45s ease,
    box-shadow 0.45s ease,
    border-color 0.45s ease,
    background 0.45s ease;
}


/* GRADIENT LAYER */

.home-service-card::before {
  content: "";

  position: absolute;

  inset: 0;

  z-index: 0;

  border-radius: inherit;

  background:
    radial-gradient(
      circle at 85% 15%,
      rgba(255, 77, 166, 0.28),
      transparent 35%
    ),
    linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.98) 0%,
      rgba(255, 235, 245, 0.97) 35%,
      rgba(255, 189, 221, 0.9) 70%,
      rgba(230, 0, 126, 0.72) 120%
    );

  opacity: 0;

  transition: opacity 0.5s ease;
}


/* KEEP CARD CONTENT ABOVE GRADIENT */

.home-service-card > * {
  position: relative;

  z-index: 1;
}


/* CARD HOVER */

.home-service-card:hover {
  transform:
    translateY(-10px)
    scale(1.012);

  border-color:
    rgba(230, 0, 126, 0.18);

  box-shadow:
    0 28px 60px rgba(75, 38, 58, 0.15),
    0 10px 30px rgba(230, 0, 126, 0.09),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.home-service-card:hover::before {
  opacity: 1;
}


/* FEATURED CENTER CARD */

.service-featured {
  background:
    linear-gradient(
      145deg,
      rgba(255, 246, 250, 0.96),
      rgba(255, 234, 244, 0.92)
    );
}


/* CARD TOP */

.service-top {
  display: flex;
  justify-content: space-between;
}

.service-number {
  color: #aa9ba2;

  font-family: "Cormorant Garamond", serif;

  font-style: italic;

  transition:
    color 0.35s ease,
    transform 0.35s ease;
}

.service-arrow {
  color: var(--pink);

  font-size: 1.3rem;

  transition:
    transform 0.35s ease,
    color 0.35s ease;
}

.home-service-card:hover .service-arrow {
  transform:
    translate(4px, -4px)
    rotate(5deg);
}

.home-service-card:hover .service-number {
  color: var(--pink);

  transform: translateX(2px);
}


/* CARD CONTENT */

.service-category {
  margin: 0 0 13px;

  color: var(--pink);

  font-size: 0.56rem;
  font-weight: 500;

  letter-spacing: 3px;
}

.service-card-content h3 {
  margin: 0 0 22px;

  font-family: "Cormorant Garamond", serif;

  font-size: clamp(2.8rem, 4vw, 4rem);
  font-weight: 400;

  transition:
    transform 0.4s ease;
}

.home-service-card:hover .service-card-content h3 {
  transform: translateX(4px);
}

.service-description {
  max-width: 330px;

  color: var(--gray);

  font-size: 0.77rem;

  line-height: 1.9;

  transition: color 0.35s ease;
}

.home-service-card:hover .service-description {
  color: #55474e;
}

.service-discover {
  display: inline-block;

  margin-top: 35px;

  padding-bottom: 5px;

  border-bottom:
    1px solid
    var(--pink);

  color: var(--black);

  font-size: 0.58rem;
  font-weight: 500;

  letter-spacing: 1.5px;

  text-transform: uppercase;

  transition:
    letter-spacing 0.35s ease,
    color 0.35s ease;
}

.home-service-card:hover .service-discover {
  color: #9d0057;

  letter-spacing: 2px;
}


/* =========================
   PHILOSOPHY
========================= */

.home-philosophy {
  min-height: 680px;

  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 130px 6%;

  background: rgba(255, 253, 251, 0.4);

  text-align: center;
}

.philosophy-content {
  max-width: 850px;

  position: relative;

  z-index: 2;
}

.home-philosophy h2 em {
  display: block;
}

.home-philosophy p:not(.home-eyebrow) {
  max-width: 650px;

  margin: 35px auto;

  color: #554e52;

  font-size: 0.85rem;

  line-height: 2;
}

.dark-link {
  justify-content: center;
}

.philosophy-decoration {
  position: absolute;

  color: rgba(230, 0, 126, 0.06);

  font-family: "Cormorant Garamond", serif;

  font-size: min(55vw, 650px);

  font-style: italic;

  line-height: 1;

  user-select: none;
}


/* =========================
   EXPERIENCE
========================= */

.home-experience {
  padding:
    125px
    max(6%, calc((100vw - 1400px) / 2));

  background: rgba(255, 248, 251, 0.74);

  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.experience-heading {
  max-width: 750px;

  margin-bottom: 75px;
}

.experience-grid {
  display: grid;

  grid-template-columns: repeat(3, 1fr);

  border-top: 1px solid #ddcfd6;
}

.experience-item {
  padding:
    40px
    45px
    20px
    0;
}

.experience-item + .experience-item {
  padding-left: 45px;

  border-left: 1px solid #ddcfd6;
}

.experience-item span {
  color: var(--pink);

  font-family: "Cormorant Garamond", serif;

  font-style: italic;
}

.experience-item h3 {
  margin: 22px 0 15px;

  font-family: "Cormorant Garamond", serif;

  font-size: 2.1rem;
  font-weight: 400;
}

.experience-item p {
  color: var(--gray);

  font-size: 0.76rem;

  line-height: 1.9;
}


/* =========================
   PROFESSIONAL
========================= */

.professional-teaser {
  padding:
    130px
    max(6%, calc((100vw - 1400px) / 2));

  background: rgba(8, 8, 8, 0.94);

  color: white;
}

.professional-inner {
  display: grid;

  grid-template-columns: 0.65fr 1.35fr;

  align-items: center;

  gap: 80px;
}

.professional-number {
  color: rgba(255, 255, 255, 0.08);

  font-family: "Cormorant Garamond", serif;

  font-size: clamp(5rem, 10vw, 10rem);

  font-style: italic;

  white-space: nowrap;
}

.professional-content {
  max-width: 680px;
}

.professional-content h2 {
  color: var(--pearl);
}

.professional-content h2 em {
  display: block;
}

.professional-content > p:not(.home-eyebrow) {
  max-width: 570px;

  margin: 32px 0;

  color: #bbb3b7;

  font-size: 0.82rem;

  line-height: 2;
}

.professional-link {
  display: inline-flex;
  align-items: center;

  gap: 13px;

  padding-bottom: 7px;

  color: var(--pearl);

  border-bottom: 1px solid var(--pink);

  text-decoration: none;
  text-transform: uppercase;

  font-size: 0.58rem;
  font-weight: 500;

  letter-spacing: 2px;
}

.professional-link span {
  color: var(--pink);
}


/* =========================
   FINAL CTA
========================= */

.home-cta {
  min-height: 620px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 120px 6%;

  background: rgba(255, 250, 252, 0.58);

  text-align: center;
}

.cta-content {
  max-width: 850px;
}

.home-cta h2 em {
  display: block;
}

.home-cta .cta-content > p:not(.home-eyebrow) {
  margin: 30px 0 35px;

  color: var(--gray);
}


/* =========================
   TABLET
========================= */

@media (max-width: 950px) {
  .services-grid {
    grid-template-columns: 1fr;
  }

  .services-header {
    align-items: flex-start;
    flex-direction: column;
  }

  .experience-grid {
    grid-template-columns: 1fr;
  }

  .experience-item,
  .experience-item + .experience-item {
    padding: 35px 0;

    border-left: 0;

    border-bottom: 1px solid #ddcfd6;
  }

  .professional-inner {
    grid-template-columns: 1fr;

    gap: 20px;
  }
}


/* =========================
   MOBILE
========================= */

@media (max-width: 600px) {
  .home-fixed-background {
    background-position: 58% center;
  }

  .home-fixed-overlay {
    background: rgba(255, 250, 252, 0.7);
  }

  .home-hero {
    min-height: calc(100vh - 76px);

    padding: 75px 7%;
  }

  .hero-title {
    font-size: clamp(3.8rem, 19vw, 5.5rem);

    line-height: 0.88;

    letter-spacing: -2px;
  }

  .hero-title span {
    margin-left: 0;
  }

  .hero-description {
    margin-left: 0;
  }

  .hero-actions {
    align-items: flex-start;
    flex-direction: column;

    margin-left: 0;
  }

  .home-intro,
  .home-services,
  .home-philosophy,
  .home-experience,
  .professional-teaser,
  .home-cta {
    padding-left: 7%;
    padding-right: 7%;
  }

  .home-intro h2,
  .services-header h2,
  .home-philosophy h2,
  .experience-heading h2,
  .professional-content h2,
  .home-cta h2 {
    font-size: clamp(3rem, 15vw, 4.5rem);
  }

  .home-service-card {
    min-height: 360px;

    border-radius: 22px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAGA;;2BAE2B;;AAE3B;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;;AAGA;;2BAE2B;;AAE3B;EACE,eAAe;;EAEf,QAAQ;;EAER,YAAY;EACZ,aAAa;;EAEb,UAAU;;EAEV,sBAAsB;EACtB,kCAAkC;EAClC,4BAA4B;;EAE5B,oBAAoB;AACtB;;;AAGA,wBAAwB;;AAExB;EACE,eAAe;;EAEf,QAAQ;;EAER,YAAY;EACZ,aAAa;;EAEb,UAAU;;EAEV;;;;;;KAMG;;EAEH,oBAAoB;AACtB;;;AAGA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;;EAEf,kBAAkB;;EAElB,UAAU;;EAEV,iBAAiB;;EAEjB,wBAAwB;;EAExB,qCAAqC;AACvC;;;AAGA;;2BAE2B;;AAE3B;EACE,gBAAgB;;EAEhB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;;EAEnB,yBAAyB;AAC3B;;;AAGA;;2BAE2B;;AAE3B;EACE,8BAA8B;;EAE9B,aAAa;EACb,mBAAmB;;EAEnB,kBAAkB;;EAElB;;uCAEqC;;EAErC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;;EAEhB,kBAAkB;;EAElB,UAAU;AACZ;;AAEA;EACE,SAAS;;EAET,mBAAmB;;EAEnB,wCAAwC;;EAExC,qCAAqC;EACrC,gBAAgB;;EAEhB,iBAAiB;;EAEjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;;EAEd,gBAAgB;;EAEhB,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,oBAAoB;;EAEpB,cAAc;;EAEd,kBAAkB;EAClB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;;EAEf,SAAS;;EAET,oBAAoB;AACtB;;;AAGA;;2BAE2B;;AAE3B;EACE,qBAAqB;;EAErB,kBAAkB;;EAElB,cAAc;;EAEd;;;;;;KAMG;;EAEH,0CAA0C;;EAE1C;uCACqC;;EAErC,qBAAqB;EACrB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;;EAEnB;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;;EAE3B;uCACqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,SAAS;;EAET,mBAAmB;;EAEnB,qBAAqB;EACrB,yBAAyB;;EAEzB,iBAAiB;EACjB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,eAAe;;EAEf,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;;2BAE2B;;AAE3B;;;;;;EAME,SAAS;;EAET,wCAAwC;;EAExC,qCAAqC;EACrC,gBAAgB;;EAEhB,iBAAiB;;EAEjB,oBAAoB;AACtB;;AAEA;;;;;EAKE,kBAAkB;;EAElB,gBAAgB;AAClB;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;;EAEjB,qCAAqC;;EAErC,0BAA0B;EAC1B,kCAAkC;;EAElC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,gBAAgB;;EAEhB,mBAAmB;;EAEnB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;;EAEhB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;EAEhB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;;EAEnB,SAAS;AACX;;AAEA;EACE,OAAO;;EAEP,WAAW;;EAEX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;;EAElB,wCAAwC;;EAExC,kBAAkB;AACpB;;;AAGA;;2BAE2B;;AAE3B;EACE;;uCAEqC;;EAErC,qCAAqC;;EAErC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;;EAErB,SAAS;;EAET,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,SAAS;;EAET,kBAAkB;;EAElB,iBAAiB;;EAEjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;;EAEb,qCAAqC;;EAErC,SAAS;AACX;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;;EAEjB,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;;EAE9B,kBAAkB;;EAElB,gBAAgB;;EAEhB,wBAAwB;;EAExB;;;;;KAKG;;EAEH;;6BAE2B;;EAE3B,mBAAmB;;EAEnB;;0CAEwC;;EAExC,qBAAqB;;EAErB,2BAA2B;EAC3B,mCAAmC;;EAEnC;;;;yBAIuB;AACzB;;;AAGA,mBAAmB;;AAEnB;EACE,WAAW;;EAEX,kBAAkB;;EAElB,QAAQ;;EAER,UAAU;;EAEV,sBAAsB;;EAEtB;;;;;;;;;;;;KAYG;;EAEH,UAAU;;EAEV,6BAA6B;AAC/B;;;AAGA,qCAAqC;;AAErC;EACE,kBAAkB;;EAElB,UAAU;AACZ;;;AAGA,eAAe;;AAEf;EACE;;gBAEc;;EAEd;2BACyB;;EAEzB;;;0CAGwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;;AAGA,yBAAyB;;AAEzB;EACE;;;;;KAKG;AACL;;;AAGA,aAAa;;AAEb;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;;EAEd,wCAAwC;;EAExC,kBAAkB;;EAElB;;wBAEsB;AACxB;;AAEA;EACE,kBAAkB;;EAElB,iBAAiB;;EAEjB;;oBAEkB;AACpB;;AAEA;EACE;;gBAEc;AAChB;;AAEA;EACE,kBAAkB;;EAElB,0BAA0B;AAC5B;;;AAGA,iBAAiB;;AAEjB;EACE,gBAAgB;;EAEhB,kBAAkB;;EAElB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;;EAEhB,wCAAwC;;EAExC,mCAAmC;EACnC,gBAAgB;;EAEhB;uBACqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;;EAElB,kBAAkB;;EAElB,gBAAgB;;EAEhB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;;EAErB,gBAAgB;;EAEhB,mBAAmB;;EAEnB;;eAEa;;EAEb,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;;EAEhB,qBAAqB;;EAErB,yBAAyB;;EAEzB;;oBAEkB;AACpB;;AAEA;EACE,cAAc;;EAEd,mBAAmB;AACrB;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;;EAEjB,kBAAkB;;EAElB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,iBAAiB;;EAEjB,oCAAoC;;EAEpC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;;EAElB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;;EAEhB,iBAAiB;;EAEjB,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;;EAElB,8BAA8B;;EAE9B,wCAAwC;;EAExC,2BAA2B;;EAE3B,kBAAkB;;EAElB,cAAc;;EAEd,iBAAiB;AACnB;;;AAGA;;2BAE2B;;AAE3B;EACE;;uCAEqC;;EAErC,qCAAqC;;EAErC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,aAAa;;EAEb,qCAAqC;;EAErC,6BAA6B;AAC/B;;AAEA;EACE;;;;KAIG;AACL;;AAEA;EACE,kBAAkB;;EAElB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;;EAElB,wCAAwC;;EAExC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;;EAEnB,wCAAwC;;EAExC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;;EAElB,gBAAgB;AAClB;;;AAGA;;2BAE2B;;AAE3B;EACE;;uCAEqC;;EAErC,+BAA+B;;EAE/B,YAAY;AACd;;AAEA;EACE,aAAa;;EAEb,oCAAoC;;EAEpC,mBAAmB;;EAEnB,SAAS;AACX;;AAEA;EACE,gCAAgC;;EAEhC,wCAAwC;;EAExC,mCAAmC;;EAEnC,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;;EAEhB,cAAc;;EAEd,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;;EAEnB,SAAS;;EAET,mBAAmB;;EAEnB,mBAAmB;;EAEnB,oCAAoC;;EAEpC,qBAAqB;EACrB,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;;2BAE2B;;AAE3B;EACE,iBAAiB;;EAEjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,iBAAiB;;EAEjB,qCAAqC;;EAErC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;;EAEnB,kBAAkB;AACpB;;;AAGA;;2BAE2B;;AAE3B;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,eAAe;;IAEf,cAAc;;IAEd,gCAAgC;EAClC;;EAEA;IACE,0BAA0B;;IAE1B,SAAS;EACX;AACF;;;AAGA;;2BAE2B;;AAE3B;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,8BAA8B;;IAE9B,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;;IAEtC,iBAAiB;;IAEjB,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;;IAEtB,cAAc;EAChB;;EAEA;;;;;;IAME,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;;;;IAME,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;;IAEjB,mBAAmB;EACrB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;1,400;1,500&family=Montserrat:wght@300;400;500;600&display=swap\");\n\n\n/* =========================\n   GLOBAL\n========================= */\n\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  margin: 0;\n  background: #fffafc;\n}\n\n\n/* =========================\n   FIXED BACKGROUND\n========================= */\n\n.home-fixed-background {\n  position: fixed;\n\n  inset: 0;\n\n  width: 100vw;\n  height: 100vh;\n\n  z-index: 0;\n\n  background-size: cover;\n  background-position: center center;\n  background-repeat: no-repeat;\n\n  pointer-events: none;\n}\n\n\n/* FADED PEARL OVERLAY */\n\n.home-fixed-overlay {\n  position: fixed;\n\n  inset: 0;\n\n  width: 100vw;\n  height: 100vh;\n\n  z-index: 1;\n\n  background:\n    linear-gradient(\n      110deg,\n      rgba(255, 253, 251, 0.72) 0%,\n      rgba(255, 250, 252, 0.67) 45%,\n      rgba(255, 244, 249, 0.62) 100%\n    );\n\n  pointer-events: none;\n}\n\n\n/* =========================\n   HOME\n========================= */\n\n.home {\n  --pink: #e6007e;\n  --pink-light: #ff4da6;\n  --black: #080808;\n  --soft-black: #181618;\n  --pearl: #f8f5f2;\n  --gray: #716a6e;\n\n  position: relative;\n\n  z-index: 2;\n\n  min-height: 100vh;\n\n  color: var(--soft-black);\n\n  font-family: \"Montserrat\", sans-serif;\n}\n\n\n/* =========================\n   EYEBROW\n========================= */\n\n.home-eyebrow {\n  margin: 0 0 22px;\n\n  color: var(--pink);\n\n  font-size: 0.62rem;\n  font-weight: 500;\n\n  letter-spacing: 4px;\n\n  text-transform: uppercase;\n}\n\n\n/* =========================\n   HERO\n========================= */\n\n.home-hero {\n  min-height: calc(100vh - 86px);\n\n  display: flex;\n  align-items: center;\n\n  position: relative;\n\n  padding:\n    100px\n    max(6%, calc((100vw - 1400px) / 2));\n\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.hero-content {\n  width: 100%;\n  max-width: 850px;\n\n  position: relative;\n\n  z-index: 2;\n}\n\n.hero-title {\n  margin: 0;\n\n  color: var(--black);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: clamp(4.8rem, 8vw, 8.8rem);\n  font-weight: 400;\n\n  line-height: 0.84;\n\n  letter-spacing: -4px;\n}\n\n.hero-title span {\n  display: block;\n\n  margin-left: 11%;\n\n  color: var(--pink);\n\n  font-style: italic;\n}\n\n.hero-description {\n  max-width: 580px;\n\n  margin: 45px 0 0 11%;\n\n  color: #494144;\n\n  font-size: 0.88rem;\n  font-weight: 400;\n\n  line-height: 1.95;\n}\n\n.hero-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n\n  gap: 32px;\n\n  margin: 40px 0 0 11%;\n}\n\n\n/* =========================\n   BUTTONS\n========================= */\n\n.home-primary-button {\n  display: inline-block;\n\n  padding: 17px 29px;\n\n  color: #ffffff;\n\n  background:\n    linear-gradient(\n      135deg,\n      #ff3ca0,\n      var(--pink),\n      #c9006e\n    );\n\n  border: 1px solid rgba(255, 255, 255, 0.4);\n\n  box-shadow:\n    0 12px 30px rgba(230, 0, 126, 0.25);\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-size: 0.61rem;\n  font-weight: 500;\n\n  letter-spacing: 2px;\n\n  transition:\n    transform 0.3s ease,\n    box-shadow 0.3s ease;\n}\n\n.home-primary-button:hover {\n  transform: translateY(-3px);\n\n  box-shadow:\n    0 18px 38px rgba(230, 0, 126, 0.35);\n}\n\n.home-text-link {\n  display: inline-flex;\n  align-items: center;\n\n  gap: 13px;\n\n  color: var(--black);\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-size: 0.6rem;\n  font-weight: 500;\n\n  letter-spacing: 2px;\n}\n\n.home-text-link span {\n  color: var(--pink);\n\n  font-size: 1rem;\n\n  transition: transform 0.3s ease;\n}\n\n.home-text-link:hover span {\n  transform: translateX(5px);\n}\n\n\n/* =========================\n   SHARED HEADINGS\n========================= */\n\n.home-intro h2,\n.services-header h2,\n.home-philosophy h2,\n.experience-heading h2,\n.professional-content h2,\n.home-cta h2 {\n  margin: 0;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: clamp(3.3rem, 6vw, 5.8rem);\n  font-weight: 400;\n\n  line-height: 0.95;\n\n  letter-spacing: -2px;\n}\n\n.home-intro h2 em,\n.home-philosophy h2 em,\n.experience-heading h2 em,\n.professional-content h2 em,\n.home-cta h2 em {\n  color: var(--pink);\n\n  font-weight: 400;\n}\n\n\n/* =========================\n   INTRO\n========================= */\n\n.home-intro {\n  padding: 145px 6%;\n\n  background: rgba(255, 253, 251, 0.72);\n\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n\n  text-align: center;\n}\n\n.intro-inner {\n  max-width: 850px;\n\n  margin: auto;\n}\n\n.intro-description {\n  max-width: 680px;\n\n  margin: 34px auto 0;\n\n  color: var(--gray);\n\n  font-size: 0.86rem;\n  font-weight: 300;\n\n  line-height: 2;\n}\n\n.intro-secondary {\n  margin-top: 15px;\n}\n\n.intro-divider {\n  max-width: 350px;\n\n  margin: 48px auto 0;\n\n  display: flex;\n  align-items: center;\n\n  gap: 20px;\n}\n\n.intro-divider span {\n  flex: 1;\n\n  height: 1px;\n\n  background: #dfcfd7;\n}\n\n.intro-divider div {\n  color: var(--pink);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-style: italic;\n}\n\n\n/* =========================\n   SERVICES\n========================= */\n\n.home-services {\n  padding:\n    120px\n    max(6%, calc((100vw - 1400px) / 2));\n\n  background: rgba(248, 243, 245, 0.76);\n\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.services-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n\n  gap: 50px;\n\n  margin-bottom: 70px;\n}\n\n.services-header-text {\n  max-width: 410px;\n\n  margin: 0;\n\n  color: var(--gray);\n\n  font-size: 0.8rem;\n\n  line-height: 1.9;\n}\n\n.services-grid {\n  display: grid;\n\n  grid-template-columns: repeat(3, 1fr);\n\n  gap: 24px;\n}\n\n\n/* =========================\n   SERVICE CARDS\n========================= */\n\n.home-service-card {\n  min-height: 470px;\n\n  padding: 32px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  position: relative;\n\n  overflow: hidden;\n\n  color: var(--soft-black);\n\n  background:\n    linear-gradient(\n      145deg,\n      rgba(255, 255, 255, 0.94),\n      rgba(255, 250, 252, 0.88)\n    );\n\n  border:\n    1px solid\n    rgba(255, 255, 255, 0.85);\n\n  border-radius: 28px;\n\n  box-shadow:\n    0 15px 45px rgba(65, 40, 52, 0.08),\n    inset 0 1px 0 rgba(255, 255, 255, 0.8);\n\n  text-decoration: none;\n\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n\n  transition:\n    transform 0.45s ease,\n    box-shadow 0.45s ease,\n    border-color 0.45s ease,\n    background 0.45s ease;\n}\n\n\n/* GRADIENT LAYER */\n\n.home-service-card::before {\n  content: \"\";\n\n  position: absolute;\n\n  inset: 0;\n\n  z-index: 0;\n\n  border-radius: inherit;\n\n  background:\n    radial-gradient(\n      circle at 85% 15%,\n      rgba(255, 77, 166, 0.28),\n      transparent 35%\n    ),\n    linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.98) 0%,\n      rgba(255, 235, 245, 0.97) 35%,\n      rgba(255, 189, 221, 0.9) 70%,\n      rgba(230, 0, 126, 0.72) 120%\n    );\n\n  opacity: 0;\n\n  transition: opacity 0.5s ease;\n}\n\n\n/* KEEP CARD CONTENT ABOVE GRADIENT */\n\n.home-service-card > * {\n  position: relative;\n\n  z-index: 1;\n}\n\n\n/* CARD HOVER */\n\n.home-service-card:hover {\n  transform:\n    translateY(-10px)\n    scale(1.012);\n\n  border-color:\n    rgba(230, 0, 126, 0.18);\n\n  box-shadow:\n    0 28px 60px rgba(75, 38, 58, 0.15),\n    0 10px 30px rgba(230, 0, 126, 0.09),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.home-service-card:hover::before {\n  opacity: 1;\n}\n\n\n/* FEATURED CENTER CARD */\n\n.service-featured {\n  background:\n    linear-gradient(\n      145deg,\n      rgba(255, 246, 250, 0.96),\n      rgba(255, 234, 244, 0.92)\n    );\n}\n\n\n/* CARD TOP */\n\n.service-top {\n  display: flex;\n  justify-content: space-between;\n}\n\n.service-number {\n  color: #aa9ba2;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-style: italic;\n\n  transition:\n    color 0.35s ease,\n    transform 0.35s ease;\n}\n\n.service-arrow {\n  color: var(--pink);\n\n  font-size: 1.3rem;\n\n  transition:\n    transform 0.35s ease,\n    color 0.35s ease;\n}\n\n.home-service-card:hover .service-arrow {\n  transform:\n    translate(4px, -4px)\n    rotate(5deg);\n}\n\n.home-service-card:hover .service-number {\n  color: var(--pink);\n\n  transform: translateX(2px);\n}\n\n\n/* CARD CONTENT */\n\n.service-category {\n  margin: 0 0 13px;\n\n  color: var(--pink);\n\n  font-size: 0.56rem;\n  font-weight: 500;\n\n  letter-spacing: 3px;\n}\n\n.service-card-content h3 {\n  margin: 0 0 22px;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: clamp(2.8rem, 4vw, 4rem);\n  font-weight: 400;\n\n  transition:\n    transform 0.4s ease;\n}\n\n.home-service-card:hover .service-card-content h3 {\n  transform: translateX(4px);\n}\n\n.service-description {\n  max-width: 330px;\n\n  color: var(--gray);\n\n  font-size: 0.77rem;\n\n  line-height: 1.9;\n\n  transition: color 0.35s ease;\n}\n\n.home-service-card:hover .service-description {\n  color: #55474e;\n}\n\n.service-discover {\n  display: inline-block;\n\n  margin-top: 35px;\n\n  padding-bottom: 5px;\n\n  border-bottom:\n    1px solid\n    var(--pink);\n\n  color: var(--black);\n\n  font-size: 0.58rem;\n  font-weight: 500;\n\n  letter-spacing: 1.5px;\n\n  text-transform: uppercase;\n\n  transition:\n    letter-spacing 0.35s ease,\n    color 0.35s ease;\n}\n\n.home-service-card:hover .service-discover {\n  color: #9d0057;\n\n  letter-spacing: 2px;\n}\n\n\n/* =========================\n   PHILOSOPHY\n========================= */\n\n.home-philosophy {\n  min-height: 680px;\n\n  position: relative;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 130px 6%;\n\n  background: rgba(255, 253, 251, 0.4);\n\n  text-align: center;\n}\n\n.philosophy-content {\n  max-width: 850px;\n\n  position: relative;\n\n  z-index: 2;\n}\n\n.home-philosophy h2 em {\n  display: block;\n}\n\n.home-philosophy p:not(.home-eyebrow) {\n  max-width: 650px;\n\n  margin: 35px auto;\n\n  color: #554e52;\n\n  font-size: 0.85rem;\n\n  line-height: 2;\n}\n\n.dark-link {\n  justify-content: center;\n}\n\n.philosophy-decoration {\n  position: absolute;\n\n  color: rgba(230, 0, 126, 0.06);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: min(55vw, 650px);\n\n  font-style: italic;\n\n  line-height: 1;\n\n  user-select: none;\n}\n\n\n/* =========================\n   EXPERIENCE\n========================= */\n\n.home-experience {\n  padding:\n    125px\n    max(6%, calc((100vw - 1400px) / 2));\n\n  background: rgba(255, 248, 251, 0.74);\n\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.experience-heading {\n  max-width: 750px;\n\n  margin-bottom: 75px;\n}\n\n.experience-grid {\n  display: grid;\n\n  grid-template-columns: repeat(3, 1fr);\n\n  border-top: 1px solid #ddcfd6;\n}\n\n.experience-item {\n  padding:\n    40px\n    45px\n    20px\n    0;\n}\n\n.experience-item + .experience-item {\n  padding-left: 45px;\n\n  border-left: 1px solid #ddcfd6;\n}\n\n.experience-item span {\n  color: var(--pink);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-style: italic;\n}\n\n.experience-item h3 {\n  margin: 22px 0 15px;\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: 2.1rem;\n  font-weight: 400;\n}\n\n.experience-item p {\n  color: var(--gray);\n\n  font-size: 0.76rem;\n\n  line-height: 1.9;\n}\n\n\n/* =========================\n   PROFESSIONAL\n========================= */\n\n.professional-teaser {\n  padding:\n    130px\n    max(6%, calc((100vw - 1400px) / 2));\n\n  background: rgba(8, 8, 8, 0.94);\n\n  color: white;\n}\n\n.professional-inner {\n  display: grid;\n\n  grid-template-columns: 0.65fr 1.35fr;\n\n  align-items: center;\n\n  gap: 80px;\n}\n\n.professional-number {\n  color: rgba(255, 255, 255, 0.08);\n\n  font-family: \"Cormorant Garamond\", serif;\n\n  font-size: clamp(5rem, 10vw, 10rem);\n\n  font-style: italic;\n\n  white-space: nowrap;\n}\n\n.professional-content {\n  max-width: 680px;\n}\n\n.professional-content h2 {\n  color: var(--pearl);\n}\n\n.professional-content h2 em {\n  display: block;\n}\n\n.professional-content > p:not(.home-eyebrow) {\n  max-width: 570px;\n\n  margin: 32px 0;\n\n  color: #bbb3b7;\n\n  font-size: 0.82rem;\n\n  line-height: 2;\n}\n\n.professional-link {\n  display: inline-flex;\n  align-items: center;\n\n  gap: 13px;\n\n  padding-bottom: 7px;\n\n  color: var(--pearl);\n\n  border-bottom: 1px solid var(--pink);\n\n  text-decoration: none;\n  text-transform: uppercase;\n\n  font-size: 0.58rem;\n  font-weight: 500;\n\n  letter-spacing: 2px;\n}\n\n.professional-link span {\n  color: var(--pink);\n}\n\n\n/* =========================\n   FINAL CTA\n========================= */\n\n.home-cta {\n  min-height: 620px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 120px 6%;\n\n  background: rgba(255, 250, 252, 0.58);\n\n  text-align: center;\n}\n\n.cta-content {\n  max-width: 850px;\n}\n\n.home-cta h2 em {\n  display: block;\n}\n\n.home-cta .cta-content > p:not(.home-eyebrow) {\n  margin: 30px 0 35px;\n\n  color: var(--gray);\n}\n\n\n/* =========================\n   TABLET\n========================= */\n\n@media (max-width: 950px) {\n  .services-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .services-header {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .experience-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .experience-item,\n  .experience-item + .experience-item {\n    padding: 35px 0;\n\n    border-left: 0;\n\n    border-bottom: 1px solid #ddcfd6;\n  }\n\n  .professional-inner {\n    grid-template-columns: 1fr;\n\n    gap: 20px;\n  }\n}\n\n\n/* =========================\n   MOBILE\n========================= */\n\n@media (max-width: 600px) {\n  .home-fixed-background {\n    background-position: 58% center;\n  }\n\n  .home-fixed-overlay {\n    background: rgba(255, 250, 252, 0.7);\n  }\n\n  .home-hero {\n    min-height: calc(100vh - 76px);\n\n    padding: 75px 7%;\n  }\n\n  .hero-title {\n    font-size: clamp(3.8rem, 19vw, 5.5rem);\n\n    line-height: 0.88;\n\n    letter-spacing: -2px;\n  }\n\n  .hero-title span {\n    margin-left: 0;\n  }\n\n  .hero-description {\n    margin-left: 0;\n  }\n\n  .hero-actions {\n    align-items: flex-start;\n    flex-direction: column;\n\n    margin-left: 0;\n  }\n\n  .home-intro,\n  .home-services,\n  .home-philosophy,\n  .home-experience,\n  .professional-teaser,\n  .home-cta {\n    padding-left: 7%;\n    padding-right: 7%;\n  }\n\n  .home-intro h2,\n  .services-header h2,\n  .home-philosophy h2,\n  .experience-heading h2,\n  .professional-content h2,\n  .home-cta h2 {\n    font-size: clamp(3rem, 15vw, 4.5rem);\n  }\n\n  .home-service-card {\n    min-height: 360px;\n\n    border-radius: 22px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
